module.exports = __webpack_public_path__ + "img/bg004.8370763c.svg";